import { render, staticRenderFns } from "./AddFacility.vue?vue&type=template&id=19212440"
import script from "./AddFacility.vue?vue&type=script&lang=js"
export * from "./AddFacility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports